import {
  Label
} from "./chunk-52NXO4YC.js";
import {
  Typography
} from "./chunk-W3K5MNAD.js";
import {
  useFormFieldContext
} from "./chunk-MJ3U6SP3.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Form/FormLabel.tsx
import React from "react";
var FormLabel = React.forwardRef(({ ...props }, ref) => {
  const field = useFormFieldContext();
  const ownProps = field?.getLabelProps ? field?.getLabelProps(props, ref) ?? { ref, ...props } : props;
  return /* @__PURE__ */ React.createElement(Label, { ...ownProps });
});
FormLabel.displayName = "FormLabel";

// src/Form/FormMessage.tsx
import React2 from "react";
var formMessageStyles = twVariants({
  base: "text-body-2",
  variants: {
    variant: {
      enabled: "text-neutral-primary",
      disabled: "text-neutral-disabled"
    },
    invalid: {
      true: "text-danger-alert-text"
    }
  },
  defaultVariants: {
    variant: "enabled"
  }
});
var FormMessage = React2.forwardRef(({ className, children, ...props }, ref) => {
  const field = useFormFieldContext();
  const ownProps = field?.getMessageProps(props, ref) ?? { ref, ...props };
  if (!children) {
    return null;
  }
  const variant = field.disabled ? "disabled" : "enabled";
  return /* @__PURE__ */ React2.createElement(
    Typography,
    {
      variant: "body-2",
      className: cn(
        formMessageStyles({ variant, invalid: !!field?.invalid }),
        className
      ),
      ...ownProps,
      ref
    },
    children
  );
});
FormMessage.displayName = "FormMessage";

export {
  FormLabel,
  FormMessage
};
//# sourceMappingURL=chunk-7F2CZQJ4.js.map